import { render } from "./AppLoading.vue?vue&type=template&id=6a413980"
import script from "./AppLoading.vue?vue&type=script&lang=js"
export * from "./AppLoading.vue?vue&type=script&lang=js"

import exportComponent from "/home/harry/Desktop/Vuejs Project/Sudavas/sudavas.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__